// src/components/Layout.js
import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import NavBar from './NavBar';
import useLangParam from '../hooks/useLangParam';
import EarlyAccessModal from './EarlyAccessModal'; // << hinzufügen

/**
 * Zentrales App-Layout.
 * - useLangParam() hält ?lang, i18n, localStorage und axios synchron.
 * - Fängt den KI-Button-Klick ab, zeigt zunächst ein Early-Access-Modal
 *   und öffnet den Chat erst nach Bestätigung.
 */
function Layout({ user, setUser, onSupportClick }) {
  // Sprache zentral synchronisieren (URL <-> i18n <-> localStorage <-> axios)
  useLangParam();

  const navigate = useNavigate();

  // Early-Access-Hinweis
  const [showAiNotice, setShowAiNotice] = useState(false);
  const [dontAskAgain, setDontAskAgain] = useState(false);

  function handleLogoutClick() {
    navigate('/logout');
  }

  // KI-Button abgefangen: erst Hinweis, dann Chat
  function handleSupportClick() {
    const skip = localStorage.getItem('skipEarlyAIWarning') === '1';
    if (skip) {
      onSupportClick?.(); // sofort öffnen
      return;
    }
    setShowAiNotice(true); // Hinweis zeigen
  }

  function handleContinue() {
    setShowAiNotice(false);
    if (dontAskAgain) {
      localStorage.setItem('skipEarlyAIWarning', '1');
    }
    onSupportClick?.(); // jetzt Chat öffnen
  }

  function handleCancel() {
    setShowAiNotice(false);
    setDontAskAgain(false);
  }

  const pageWrap = {
    minHeight: '100vh',
    background: '#0b0f0a',
    display: 'flex',
    flexDirection: 'column',
  };

  return (
    <div style={pageWrap}>
      <NavBar
        user={user}
        onLogoutClick={handleLogoutClick}
        onSupportClick={handleSupportClick} // << hier abfangen
      />

      {/* Seiteninhalte */}
      <Outlet />

      {/* Early-Access Modal (Beta-Hinweis) */}
      <EarlyAccessModal
        open={showAiNotice}
        onContinue={handleContinue}
        onCancel={handleCancel}
        dontAskAgain={dontAskAgain}
        setDontAskAgain={setDontAskAgain}
      />
    </div>
  );
}

export default Layout;
